import React from 'react';
import { components } from 'react-select';
import Loader from 'components/Loader';

export default (props) => {
    let className = `${props.className} fm-select__loading-indicator`;
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props} className={className}>
                <Loader type="xsmall" />
            </components.DropdownIndicator>
        )
    );
};
